import InMemoryStorage from './InMemoryStorage';
import SafeStorage from './SafeStorage';
import { type Options } from './types';

// eslint-disable-next-line import/no-anonymous-default-export
export default class extends SafeStorage {
	constructor(options?: Options) {
		let storageToUse;
		try {
			// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
			storageToUse = window.sessionStorage || InMemoryStorage;
		} catch (err) {
			storageToUse = InMemoryStorage;
		}
		super(storageToUse, options);
	}
}
